import React from 'react'
import PropTypes from 'prop-types'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { FormattedMessage } from 'react-intl'
import { useAIRiskReportExportMode } from '../RenderMode/AIRiskReportRenderModeProvider'
import styles from './InfoTooltip.module.scss'

export default function InfoTooltip({ id, messageId, children }) {
  const isExportMode = useAIRiskReportExportMode()

  if (isExportMode) {
    return <span>{children}</span>
  }

  return (
    <OverlayTrigger
      placement="top"
      overlay={
        <Tooltip id={id} className={styles.tooltip}>
          <FormattedMessage id={messageId} />
        </Tooltip>
      }
    >
      <button type="button" className={`${styles.cell} d-inline-flex align-items-center gap-2`}>
        {children}
        <i className={`fa-regular fa-circle-info ${styles.icon}`} aria-hidden="true" />
      </button>
    </OverlayTrigger>
  )
}

InfoTooltip.propTypes = {
  id: PropTypes.string.isRequired,
  messageId: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
}
